<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'570px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onChange="onModalChange" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'repay',
      getListUrl: 'repayrec',
      breadcrumb: [
        { name: "财务管理", path: `/finance/shipper` },
        { name: "应收账款管理", path: `/finance/shipper` },
        { name: "还款记录" },
      ],
      formInline: {
      },
      formCtrl: [
        {
          ...this.ctrls.month,
          label: "还款日期",
          keyName: "repaytime",
        },
      ],
      cols: [
        { prop: "custom", label: "客户名称" },
        { prop: "paymoney", label: "还款金额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "repaytime", label: "还款日期" },
        { prop: "remark", label: "备注" },
      ],
      getTotalProperty: ["paymoney"],
      btns: [
        {
          ...this.viewBtn,
          title: "还款记录",
          cb: ({ id, custom, paymoney, repaytime, photo, remark, cid }) => {
            // console.log(id)
            this.title = '还款记录'
            this.viewMode = true
            this.mform = { id, customname: custom, paymoney, repaytime, photo, remark, cid }
            // console.log({ ...this.mform })
            this.showDialog()
          },
        },
      ],
      title: '还款记录',
      mform: {
        paymoney: undefined,
        repaytime: undefined,
        photo: undefined,
      },
      mrules: {
        paymoney: [
          {
            required: true,
            message: '请填写还款金额',
            trigger: 'blur',
          }
        ],
        repaytime: [
          {
            required: true,
            message: '请选择还款日期',
            trigger: 'blur',
          }
        ],
        photo: [
          {
            required: true,
            message: '请上传还款凭证',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "还款人",
          keyName: "customname",
          type: "text",
          disabled: true,
        },
        {
          label: "还款金额",
          keyName: "paymoney",
          err: "请填写还款金额",
          type: "number",
        },
        {
          label: "还款日期",
          keyName: "repaytime",
          err: "请选择还款日期",
          type: "date",
        },
        {
          label: "还款凭证",
          keyName: "photo",
          tips: "最多上传10张图片",
          type: "file",
          max: 10,
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
        },
      ],
      viewMode: false,
      baseParams: ['shipperid'],
    };
  },
  methods: {
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }

      const opt = params.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'receivable',
      }
    },

    addItem() {
      this.title = '添加还款记录'
      this.viewMode = false
      const { pname, shipperid } = this.$route.query
      this.mform = {
        customname: pname,
        cid: shipperid,
        paymoney: undefined,
        repaytime: undefined,
        photo: undefined,
      }
      // console.log({ ...this.mform })
      this.showDialog()
    },
  },
  mounted() {
    const { pname } = this.$route.query
    this.mform.pname = pname
    this.breadcrumb[2].name = pname + '还款记录'
    // console.log({ ...this.mform })
    this.$forceUpdate()
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {
    padding-right: 50px;

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 100%;
    }
  }

  // .btns {
  //   margin-left: 110px;
  // }
}

/deep/ .el-dialog .btns .mians {
  text-align: center;
}</style>
